import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { ApplicationsStatuses } from "./supabase";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getStatusLabel = (status: ApplicationsStatuses, t: any) => {
  switch (status) {
    case "screening":
      return t("status_labels.application_status.screening");
    case "paused":
      return t("status_labels.application_status.paused");
    case "hired":
      return t("status_labels.application_status.hired");
    case "declined":
      return t("status_labels.application_status.declined");
    case "invited_to_interview":
      return t("status_labels.application_status.invited_to_interview");
    case "failed_interview":
      return t("status_labels.application_status.failed_interview");
    case "passed_interview":
      return t("status_labels.application_status.passed_interview");
    default:
      return t("status_labels.application_status.unknown");
  }
};
